import { List } from 'antd';
import React, { useState, useEffect } from 'react';
import ReportDoc from '../../../components/ReportDoc/ReportDoc';
import { useNavigate } from 'react-router-dom';

const HiredDtl = (props) => {

    const navigate = useNavigate();
    const [data] = useState([
        {
            id: 1,
            name: 'Цалин',
            path: 'salaryreport'
        },
        {
            id: 2,
            name: 'Ажилд орсон',
            path: 'hiredreport'
        },
        {
            id: 3,
            name: 'Ажлаас гарсан',
            path: 'terminatedreport'
        },
        {
            id: 4,
            name: 'Дотоод шилжилт',
            path: 'shiftreport'
        },
        {
            id: 8,
            name: 'Цалинд өөрчлөлт орсон',
            path: 'salarychangereport'
        },
        {
            id: 9,
            name: 'Даатгуулагчийн төрөл өөрчлөгдсөн',
            path: 'insuretypechangereport'
        },
        {
            id: 10,
            name: 'Хөдөлмөрийн нөхцөл өөрчлөгдсөн',
            path: 'laborconditionchangedreport'
        },
        {
            id: 12,
            name: 'Ажилласан жил',
            path: 'workedyear'
        }
    ]);

    const onPressNode = (p_item) => {
        navigate('/hrsuite/report/hired/' + p_item.path);
    }

    const renderItem = (item) => {
        return (
            <ReportDoc data={item} onClick={onPressNode} />
        );
    }

    return (
        <div style={{ marginTop: 16 }}>
            <List
                grid={{
                    gutter: [0, 16]
                }}
                dataSource={data}
                renderItem={renderItem}
            />
        </div>
    );
}

export default HiredDtl;